import { IGridWallRequest } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllGridWallRequests = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/grid-wall-requests`
    );

    return data as IGridWallRequest[];
};

export const getGridWallRequest = async (gridwallId: string) => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/grid-wall-requests/${gridwallId}`
    );

    return data as IGridWallRequest;
};
